import axios from "axios";

export default {

    data: () => ({
        companies: [],
        page: 1,
        pages: 0,

        support_date_dialog: false,
        new_support_date: '',
        selected_id: "",

        change_user_dialog: false,
        selected_user: '',
        phone: "",
        user_details: '',

        // search
        economicCode: "",
        user: "",
        name: "",


        // selects

    }),

    mounted() {
        this.get_companies()
    },

    methods: {

        async get_companies() {
            this.$store.commit('progress_status', true)
            await axios({
                method: "GET",
                url: "/companies",
                headers: {
                    token: sessionStorage.getItem("token")
                },
                params: {
                    page: this.page,
                    economicCode: this.economicCode,
                    user: this.user,
                    name: this.name,
                }
            })
                .then((res) => {
                    console.log(res.data)
                    this.companies = res.data
                    this.pages = res.data.pages
                })
                .catch((err) => {
                    console.log(err);
                    if (err.message ===
                        "Network Error") {
                        this.$store.commit('snackbar', { color: 'red', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                    }
                })
                .finally(() => {
                    this.$store.commit('progress_status', false)
                });
        },

        async change_activity(id) {
            let status
            for (let i = 0; i < this.companies.docs.length; i++) {
                if (this.companies.docs[i].id == id) {
                    status = this.companies.docs[i].isActive
                }
            }
            await axios({
                method: "PATCH",
                url: "/company-active",
                headers: {
                    token: sessionStorage.getItem("token") || localStorage.getItem("token")
                },
                params: {
                    company: sessionStorage.getItem("company"),
                    id,
                },
                data: {
                    isActive: !status
                }
            })
                .then((res) => {
                    console.log(res.data);
                    this.$store.commit('snackbar', { color: 'green', text: res.data })

                })
                .catch((err) => {
                    console.log(err);
                    this.$store.commit('snackbar', { color: '#D50000', text: err.response.data })
                    if (err.message ===
                        "Network Error") {
                        this.$store.commit('snackbar', { color: '#D50000', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                    }
                    if (err.response.status === 403) {
                        this.$store.commit('snackbar', { color: '#D50000', text: 'توکن شما منقضی شده' })
                        sessionStorage.clear()
                        localStorage.clear()
                        router.push({ name: "login" })
                    }
                })
                .finally(() => {
                    this.$store.commit('progress_status', false)

                });
        },

        async change_payed(id) {
            let status
            for (let i = 0; i < this.companies.docs.length; i++) {
                if (this.companies.docs[i].id == id) {
                    status = this.companies.docs[i].isPayed
                }
            }
            await axios({
                method: "PATCH",
                url: "/company-pay",
                headers: {
                    token: sessionStorage.getItem("token") || localStorage.getItem("token")
                },
                params: {
                    company: sessionStorage.getItem("company"),
                    id,
                },
                data: {
                    isPayed: !status
                }
            })
                .then((res) => {
                    console.log(res.data);
                    this.$store.commit('snackbar', { color: 'green', text: res.data })

                })
                .catch((err) => {
                    console.log(err);
                    this.$store.commit('snackbar', { color: '#D50000', text: err.response.data })
                    if (err.message ===
                        "Network Error") {
                        this.$store.commit('snackbar', { color: '#D50000', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                    }
                    if (err.response.status === 403) {
                        this.$store.commit('snackbar', { color: '#D50000', text: 'توکن شما منقضی شده' })
                        sessionStorage.clear()
                        localStorage.clear()
                        router.push({ name: "login" })
                    }
                })
                .finally(() => {
                    this.$store.commit('progress_status', false)

                });
        },


        open_support_date_dialog(id) {
            this.support_date_dialog = true
            this.selected_id = id
        },

        async change_support_date() {

            if (!this.new_support_date) {
                this.$store.commit('snackbar', { color: 'red', text: "تاریخی را مشخص کنید" })

            }
            else {
                this.$store.commit('progress_status', true)
                await axios({
                    method: "PATCH",
                    url: "/comapny-support",
                    headers: {
                        token: sessionStorage.getItem("token")
                    },
                    params: {
                        id: this.selected_id,
                    },
                    data: {
                        supportDate: this.new_support_date
                    }
                })
                    .then((res) => {
                        console.log(res.data);
                        this.$store.commit('snackbar', { color: 'green', text: res.data })
                        this.close_dialog()
                        this.get_companies()
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$store.commit('snackbar', { color: '#D50000', text: err.response.data })
                        if (err.message ===
                            "Network Error") {
                            this.$store.commit('snackbar', { color: '#D50000', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                        }
                        if (err.response.status === 403) {
                            this.$store.commit('snackbar', { color: '#D50000', text: 'توکن شما منقضی شده' })
                            sessionStorage.clear()
                            localStorage.clear()
                            router.push({ name: "login" })
                        }
                    })
                    .finally(() => {
                        this.$store.commit('progress_status', false)

                    });
            }
        },


        open_change_user_dialog(id) {
            this.change_user_dialog = true
            this.selected_id = id
        },

        async search_users() {

            if (!this.phone) {
                this.$store.commit('snackbar', { color: 'red', text: "شماره تلفن معتبر وارد کنید." })
            }
            else {
                this.$store.commit('progress_status', true)
                await axios({
                    method: "GET",
                    url: "/users",
                    headers: {
                        token: sessionStorage.getItem("token")
                    },
                    params: {
                        phone: this.phone,
                    },
                })
                    .then((res) => {
                        console.log(res.data.docs[0]);
                        this.user_details = res.data.docs[0]
                        this.selected_user = res.data.docs[0].id

                    })
                    .catch((err) => {
                        console.log(err);
                        this.$store.commit('snackbar', { color: '#D50000', text: err.response.data })
                        if (err.message ===
                            "Network Error") {
                            this.$store.commit('snackbar', { color: '#D50000', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                        }
                        if (err.response.status === 403) {
                            this.$store.commit('snackbar', { color: '#D50000', text: 'توکن شما منقضی شده' })
                            sessionStorage.clear()
                            localStorage.clear()
                            router.push({ name: "login" })
                        }
                    })
                    .finally(() => {
                        this.$store.commit('progress_status', false)

                    });
            }
        },

        async change_users() {
            // console.log(this.selected_user);

            if (!this.selected_user) {
                this.$store.commit('snackbar', { color: 'red', text: "کاربری پیدا نشد" })
            }
            else {
                this.$store.commit('progress_status', true)
                await axios({
                    method: "PATCH",
                    url: "/comapny-change",
                    headers: {
                        token: sessionStorage.getItem("token")
                    },
                    params: {
                        id: this.selected_id,
                    },
                    data: {
                        user: this.selected_user
                    }
                })
                    .then((res) => {
                        console.log(res.data);
                        this.$store.commit('snackbar', { color: 'green', text: res.data })
                        this.close_dialog()
                        this.get_companies()
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$store.commit('snackbar', { color: '#D50000', text: err.response.data })
                        if (err.message ===
                            "Network Error") {
                            this.$store.commit('snackbar', { color: '#D50000', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
                        }
                        if (err.response.status === 403) {
                            this.$store.commit('snackbar', { color: '#D50000', text: 'توکن شما منقضی شده' })
                            sessionStorage.clear()
                            localStorage.clear()
                            router.push({ name: "login" })
                        }
                    })
                    .finally(() => {
                        this.$store.commit('progress_status', false)

                    });
            }
        },

        close_dialog() {
            this.change_user_dialog = false
            this.support_date_dialog = false
            this.user_details = ''
            this.new_support_date = ''
            this.selected_user = ''
            this.phone = ''
        },

        show_all() {
            this.economicCode = ''
            this.user = ''
            this.name = ''
            this.get_companies()
          },


    }
};